import { groupBy, partition, sortDates } from "../../../omnia"
import { Layer, LayerType, ManagementTask, SelectionField } from "../../types"
import { FieldLayerTypesPopup } from "./FieldLayerTypes"
import { TrimLayers } from "./TrimLayers"

interface Props {
    field: SelectionField
    tasks: ManagementTask[]
    layerTypes: LayerType[]
}

export function FieldDetails({ field, tasks, layerTypes }: Props) {

    return <div className="details">

        <Details field={field} layerTypes={layerTypes} />

        <TrimLayers field={field} tasks={tasks} />

    </div>

}


function Details({ field, layerTypes }: Pick<Props, "field" | "layerTypes">) {

    const info = React.useMemo(() => {

        const [dynamic, fixed] = partition(field.layers, l => l.dynamicScale)

        const tasks = groupBy(field.layers, l => l.taskId)

        return {
            layers: {
                total: fixed.length + dynamic.length,
                fixed,
                dynamic
            },
            tasks,
            sets: field.setIds,
            samplingDate: getSamplingDate(field.layers),
            importDate: getImportdate(field.layers)
        }

    }, [field])

    return <div className="info">

        <div>
            <span>Layers:</span> {info.layers.total} ({info.layers.fixed.length} fixed scale, {info.layers.dynamic.length} dynamic scale)
            <FieldLayerTypesPopup field={field} layerTypes={layerTypes} />
        </div>

        <div>
            <span>Sampling date:</span> {info.samplingDate}
        </div>

        <div>
            <span>Import date:</span> {info.importDate}
        </div>

        <div>
            <span>Sets ids:</span> {info.sets.join(", ")}
        </div>

    </div>

}

function getSamplingDate(layers: Layer[]) {

    const dates = layers
        .map(l => l.date)
        .filter(d => !!d)
        .map(d => new Date(d).toLocaleDateString())

    const groups = groupBy(dates, d => d).map(g => ({ date: g.key, count: g.values.length })).sort((a, b) => b.count - a.count)

    return groups[0]?.date


}

function getImportdate(layers: Layer[]) {

    const dates = layers
        .map(l => l.importDate)
        .filter(d => !!d)
        .map(d => new Date(d))
        .sort((a, b) => sortDates(a, b))

    return dates[0]?.toLocaleDateString()

}
